let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("l12Dg")).then(() => parcelRequire('U4Few'));